var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardSofteam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1203,
    height: 677,
    viewBox: "0 0 1203 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.27 1H6.14001C3.37859 1 1.14001 3.23858 1.14001 6V670.69C1.14001 673.451 3.37859 675.69 6.14001 675.69H266.27C269.031 675.69 271.27 673.451 271.27 670.69V6C271.27 3.23858 269.031 1 266.27 1Z",
    fill: "url(#paint0_linear_1_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.27 1H6.14001C3.37859 1 1.14001 3.23858 1.14001 6V670.69C1.14001 673.451 3.37859 675.69 6.14001 675.69H266.27C269.031 675.69 271.27 673.451 271.27 670.69V6C271.27 3.23858 269.031 1 266.27 1Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.7 1H21.14C10.0943 1 1.14001 9.9543 1.14001 21V655.69C1.14001 666.736 10.0943 675.69 21.14 675.69H1181.7C1192.75 675.69 1201.7 666.736 1201.7 655.69V21C1201.7 9.9543 1192.75 1 1181.7 1Z",
    fill: "url(#paint1_linear_1_5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.7 1H21.14C10.0943 1 1.14001 9.9543 1.14001 21V655.69C1.14001 666.736 10.0943 675.69 21.14 675.69H1181.7C1192.75 675.69 1201.7 666.736 1201.7 655.69V21C1201.7 9.9543 1192.75 1 1181.7 1Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.85 675.34V586.55H985.45",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.68 675.03L1090.5 520.27V489.63",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.68 550.91H1039.23V538.05",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.18 395.48L924.8 395.21",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M809.83 675.34V550.91",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M810.83 631.34H888.01",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M855.14 633.44V502.66",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M997.42 395.21V472.66",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.49 489.63H1144.28V544.48",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.9 395.21L1108.63 241.39",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.63 262.56H997.42",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M924.8 675.03L925.4 538.05",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.02 0.660004V139.44",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.02 101.12L1044.69 101.21",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M997.33 477.13C999.749 477.13 1001.71 475.169 1001.71 472.75C1001.71 470.331 999.749 468.37 997.33 468.37C994.911 468.37 992.95 470.331 992.95 472.75C992.95 475.169 994.911 477.13 997.33 477.13Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.23 542.16C1041.65 542.16 1043.61 540.199 1043.61 537.78C1043.61 535.361 1041.65 533.4 1039.23 533.4C1036.81 533.4 1034.85 535.361 1034.85 537.78C1034.85 540.199 1036.81 542.16 1039.23 542.16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.5 494.01C1092.92 494.01 1094.88 492.049 1094.88 489.63C1094.88 487.211 1092.92 485.25 1090.5 485.25C1088.08 485.25 1086.12 487.211 1086.12 489.63C1086.12 492.049 1088.08 494.01 1090.5 494.01Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.28 549.04C1146.7 549.04 1148.66 547.079 1148.66 544.66C1148.66 542.241 1146.7 540.28 1144.28 540.28C1141.86 540.28 1139.9 542.241 1139.9 544.66C1139.9 547.079 1141.86 549.04 1144.28 549.04Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M982.33 590.93C984.749 590.93 986.71 588.969 986.71 586.55C986.71 584.131 984.749 582.17 982.33 582.17C979.911 582.17 977.95 584.131 977.95 586.55C977.95 588.969 979.911 590.93 982.33 590.93Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M924.8 542.16C927.219 542.16 929.18 540.199 929.18 537.78C929.18 535.361 927.219 533.4 924.8 533.4C922.381 533.4 920.42 535.361 920.42 537.78C920.42 540.199 922.381 542.16 924.8 542.16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M924.8 399.59C927.219 399.59 929.18 397.629 929.18 395.21C929.18 392.791 927.219 390.83 924.8 390.83C922.381 390.83 920.42 392.791 920.42 395.21C920.42 397.629 922.381 399.59 924.8 399.59Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M855.14 503.63C857.559 503.63 859.52 501.669 859.52 499.25C859.52 496.831 857.559 494.87 855.14 494.87C852.721 494.87 850.76 496.831 850.76 499.25C850.76 501.669 852.721 503.63 855.14 503.63Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M888.28 635.82C890.699 635.82 892.66 633.859 892.66 631.44C892.66 629.021 890.699 627.06 888.28 627.06C885.861 627.06 883.9 629.021 883.9 631.44C883.9 633.859 885.861 635.82 888.28 635.82Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M809.75 555.29C812.169 555.29 814.13 553.329 814.13 550.91C814.13 548.491 812.169 546.53 809.75 546.53C807.331 546.53 805.37 548.491 805.37 550.91C805.37 553.329 807.331 555.29 809.75 555.29Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M997.33 267.03C999.749 267.03 1001.71 265.069 1001.71 262.65C1001.71 260.231 999.749 258.27 997.33 258.27C994.911 258.27 992.95 260.231 992.95 262.65C992.95 265.069 994.911 267.03 997.33 267.03Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.63 241.4C1111.05 241.4 1113.01 239.439 1113.01 237.02C1113.01 234.601 1111.05 232.64 1108.63 232.64C1106.21 232.64 1104.25 234.601 1104.25 237.02C1104.25 239.439 1106.21 241.4 1108.63 241.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.69 105.82C1047.11 105.82 1049.07 103.859 1049.07 101.44C1049.07 99.021 1047.11 97.06 1044.69 97.06C1042.27 97.06 1040.31 99.021 1040.31 101.44C1040.31 103.859 1042.27 105.82 1044.69 105.82Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.2 144C1136.62 144 1138.58 142.039 1138.58 139.62C1138.58 137.201 1136.62 135.24 1134.2 135.24C1131.78 135.24 1129.82 137.201 1129.82 139.62C1129.82 142.039 1131.78 144 1134.2 144Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.9 322.99L1015.15 322.88",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.47 327.69C1017.89 327.69 1019.85 325.729 1019.85 323.31C1019.85 320.891 1017.89 318.93 1015.47 318.93C1013.05 318.93 1011.09 320.891 1011.09 323.31C1011.09 325.729 1013.05 327.69 1015.47 327.69Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.18 193.1H961.79",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M962.32 197.63C964.739 197.63 966.7 195.669 966.7 193.25C966.7 190.831 964.739 188.87 962.32 188.87C959.901 188.87 957.94 190.831 957.94 193.25C957.94 195.669 959.901 197.63 962.32 197.63Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.88 192.89V303.3",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.04 307.68C1175.46 307.68 1177.42 305.719 1177.42 303.3C1177.42 300.881 1175.46 298.92 1173.04 298.92C1170.62 298.92 1168.66 300.881 1168.66 303.3C1168.66 305.719 1170.62 307.68 1173.04 307.68Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5",
    x1: 1.14001,
    y1: 338.34,
    x2: 271.27,
    y2: 338.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7FD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7FD2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5",
    x1: 1.14001,
    y1: 338.34,
    x2: 1201.7,
    y2: 338.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7FD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#76CEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5CC4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#33B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#009EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0078AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0058D4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSofteam);
export default __webpack_public_path__ + "static/media/CardSofteam.9c8a303706fdd37403593f08222e0975.svg";
export { ForwardRef as ReactComponent };